<script>
	import Slide from "./Slide.svelte";
	import { db, fb } from "./firebase";
	import { onMount, onDestroy } from 'svelte';
	import { collectionData, docData } from "rxfire/firestore";
	import { startWith, toArray } from "rxjs/operators";
	import { v4 as uuid } from 'uuid';
	import { orderBy } from 'lodash';
	import Sortable from "./SortableSimple.svelte";
	import Dropzone from "svelte-file-dropzone";
	import {notifications} from './notifications.js'

	import { doc, getDoc } from "firebase/firestore";

	import { createEventDispatcher } from "svelte";

	export const dispatch = createEventDispatcher();


	// User ID passed from parent
	export let uid;
	export let permissions;
	export let boardID;
	export let title;

	export let uploading;
	console.log(boardID)

	// Form Text
	let text = "some task";

	let files, input;

	// for grid
	let items;

	// Query requires an index, see screenshot below
	// const query = db.collection('todos').where('uid', '==', uid).orderBy('created');
	// let query = db.collection(boardID).where("uid", "==", uid);

	let query = db.collection(`/decks/${boardID}/slides`)
	let todos = collectionData(query, "id").pipe(startWith([]));

	let orderQuery = db.collection("decks").doc(boardID)
	let list = docData(orderQuery, "slides_ids").pipe(startWith([]));

	// const list = getSlides("j7SeT9QuzwRL4sVsIuh7")

	const handle_keydown = e => {
		if (e.metaKey && e.which === 90) { // Z
			e.preventDefault();
			undo(boardID)
			// (e.shiftKey ? redo : undo(boardID))();
		}
	};

	async function redo(){
		console.log("redo")
	}

	$: if (boardID !== '') {       // make it react to changes (in the parent)
	//  query = db.collection(boardID).where("uid", "==", uid);
		query = db.collection(`/decks/${boardID}/slides`)
		todos = collectionData(query, "id").pipe(startWith([]));

		orderQuery = db.collection("decks").doc(boardID)
		list = docData(orderQuery, "slides_ids").pipe(startWith([]));
  }; 


	async function onChange(event) {
		const { files} = event.detail;
		// const image = files[0]

		if (files != null) {
			// firebase upload
			const storageRef = fb.storage().ref();
			// 'file' comes from the Blob or File API
			var collectionName = "test";
			const fileRef = storageRef.child(collectionName + "/" + files[0].name);
			const name = files[0].name;
			var newMetadata = {
				cacheControl: "public,max-age=3000",
			};
			await fileRef.put(files[0], newMetadata);
			fileRef.getDownloadURL().then((url) => {
				const block_id = uuid();
				text = name
				db.collection(boardID).doc(block_id).set({ uid, text, url, blockid: block_id, complete: false, className: "_2x2", created: Date.now(), order: $todos.length });
			});
		}else{
			db.collection("todos").add({ uid, text, blockid: uuid() ,complete: false, created: Date.now() });
		}

		// files = null;

		// db.collection("todos").add({ uid, text, complete: false, created: Date.now() });
		text = "";
	}


	function updateStatus(event) {
		const { blockid, newSize } = event.detail;

		console.log("block ID: " + blockid)
		console.log("newSize:  " + newSize)
		// db.collection("todos").doc(blockid).update({ size: newSize });
		var updateQuery = db.collection(`/decks/${boardID}/slides`)
											// .where('block_id','==',blockid);
		updateQuery.get().then(function(querySnapshot) {
			querySnapshot.forEach(function(doc) {
				if(doc.data().block_id == blockid){
					doc.ref.update({ size: newSize });
				}
			});
		});
	}



	function removeItem(event) {
		const { blockid } = event.detail;
		removeSlide(boardID, blockid)
	}

	function onReorder(event) {
		// const { newArray } = event.detail;
		const {from, to} = event.detail;
		console.log("from: " + from)
		console.log("to:   " + to)
		// TODO
		// run the reorder array function!!!
		moveSlide(boardID, from, to)
	}

	export let appElement;
	
	onMount(() => {
		appElement = document.body;
		document.onpaste = function (event) {
			// use event.originalEvent.clipboard for newer chrome versions
			var items = (event.clipboardData  || event.originalEvent.clipboardData).items;
			// console.log(JSON.stringify(items)); // will give you the mime types
			// find pasted image among pasted items
			var blob = null;
			for (var i = 0; i < items.length; i++) {
				if (items[i].type.indexOf("image") === 0) {
					blob = items[i].getAsFile();
				}
			}
			// load image if there is a pasted image
			if (blob !== null) {
				var files = [];
				files.push(blob);
				var event = {
					detail:{
						files: files
					}
				}
				createSlide(event)
				// var reader = new FileReader();
				// reader.onload = function(event) {
				// 	console.log(event.target.result); // data url!
				// 	// document.getElementById("pastedImage").src = event.target.result;
				// };
				// reader.readAsDataURL(blob);
			}
		}
	})

	onDestroy(()=>{
		appElement.classList.remove("dark")
	})

	$: if (appElement !== '' && appElement != undefined) {       // make it react to changes (in the parent)
			if(boardID != '' && boardID != undefined){
					appElement.classList.add("dark")
					console.log(appElement)
			}
  }; 

	
	


	// https://medium.com/swlh/reorder-with-google-cloud-firestore-8e13ea9f7fb9



	// Create New Slide
	async function createSlide(event) {
		const { files } = event.detail
		let finalUrl;
		let deckId = boardID;

		uploading = 'true';

		const storageRef = fb.storage().ref();
			// 'file' comes from the Blob or File API
		var collectionName = "test";
		for(var i=0; i<files.length; i++){
			// loop thru files plz
			var timestamp = new Date().toString();
			const fileRef = storageRef.child(collectionName + "/" + files[i].name+"_"+timestamp);
			const name = files[i].name;
			var newMetadata = {
				cacheControl: "public,max-age=3000",
			};
			await fileRef.put(files[i], newMetadata);

			finalUrl = await fileRef.getDownloadURL();
			console.log(finalUrl)

			const data = {
				content: name,
				uid,
				text,
				url: finalUrl,
				className: "_2x2",
				created: Date.now()
			};

			const doc = await db.collection(`/decks/${deckId}/slides`)
												.add(data);
			
			console.log('Slide created in ' + deckId, {
				id: doc.id,
				data: data
			});
			
			db.collection(`/decks/${deckId}/slides`).doc(doc.id).update({ block_id: doc.id });
			
			await updateDeck(deckId, doc.id);
			await updateHistory(deckId, doc.id, {
				function: "add",
				data: {
					slide_id: doc.id
				}
			})
		}
		uploading = 'false';
	}

	// Update Deck Here
	async function updateDeck(deckId, slideId) {
		// const firestore = firebase.firestore();
		
		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		console.log(snapshot);
		if (!data.slides_ids || data.slides_ids.length <= 0) {
			data.slides_ids=[]
			data.slides_ids.slides = [];
		}
		// Add the newly created slide ID to the list of slides
		data.slides_ids.push(slideId);
		// ADD DATA TO FRONT!
		// data.slides_ids.unshift(slideId)

		await db
				.collection('decks')
				.doc(deckId)
				.set(data, {merge: true});
		
		console.log('Deck updated');
	}

		// Update Deck Here
		async function updateHistory(deckId, slideId, actionData) {
		// const firestore = firebase.firestore();
		
		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		console.log(snapshot);
		if (!data.history || data.history.length <= 0) {
			data.history=[]
		}
		// Add the newly created slide ID to the list of slides
		data.history.push(actionData);
		// data.history.pop()
		// ADD DATA TO FRONT!
		// data.slides_ids.unshift(slideId)

		await db
				.collection('decks')
				.doc(deckId)
				.set(data, {merge: true});
		
		console.log('History updated');
	}

	// Update Deck Here
	async function undo(deckId, actionData) {
		// const firestore = firebase.firestore();
		
		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		console.log(snapshot);
		if (!data.history || data.history.length <= 0) {
			data.history=[]
		}
		// Add the newly created slide ID to the list of slides
		// data.history.push(actionData);
		var h = data.history.pop()
		await db
				.collection('decks')
				.doc(deckId)
				.set(data, {merge: true});
		
		console.log('History updated');


		if(h.function == "add"){
			console.log("undo add")
			const removeId = h.data.slide_id
			removeSlide(deckId, removeId, true);

		}else if(h.function == "remove"){
			console.log("undo remove")
			const addId = h.data.slide_id
			updateDeck(deckId, addId);
		}
		// ADD DATA TO FRONT!
		// data.slides_ids.unshift(slideId)

		
		
	}

	// Print All Slides
	async function printSlides(deckId) {
		// const firestore = firebase.firestore();

		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		if (!data.slides_ids || data.slides_ids.length <= 0) {
			console.error('No slides to print');
			return;
		}

		const promises = data.slides_ids.map((slideId) => {
			return printSlide(deckId, slideId);
		});

		await Promise.all(promises);
	}

	async function getSlides(deckId) {
		// const firestore = firebase.firestore();

		let array = []

		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		if (!data.slides_ids || data.slides_ids.length <= 0) {
			console.error('No slides to print');
			return;
		}

		data.slides_ids.map((slideId) => {
			// return printSlide(deckId, slideId);
			array.push(getSlide(deckId, slideId))
		});

		// await Promise.all(promises);
		return array;
	}


	// Print Individual Slide
	async function printSlide(deckId, slideId) {
		// const firestore = firebase.firestore();

		const snapshot = await db
				.collection(`/decks/${deckId}/slides`)
				.doc(slideId)
				.get();

		if (!snapshot.exists) {
			console.error('Slide not found');
			return;
		}

		const data = snapshot.data();

		console.log('Slide print', data.content);
	}

	async function getSlide(deckId, slideId) {
		// const firestore = firebase.firestore();

		const snapshot = await db
				.collection(`/decks/${deckId}/slides`)
				.doc(slideId)
				.get();

		if (!snapshot.exists) {
			console.error('Slide not found');
			return;
		}

		const data = snapshot.data();

		// console.log('Slide print', data.content);
		return data;
	}

	// Move Slides
	async function moveSlide(deckId, from, to) {
		// const firestore = firebase.firestore();



		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		if (!data.slides_ids || data.slides_ids.length <= 0) {
			console.error('No slides to move');
			return;
		}

		data.slides_ids.splice(to, 0, ...data.slides_ids.splice(from, 1));

		await db
				.collection('decks')
				.doc(deckId)
				.set(data, {merge: true});

		console.log('Deck updated');
	}

	// Delete Slides
	async function removeSlide(deckId, blockid, isUndo) {
		// const firestore = firebase.firestore();
		const snapshot = await db
				.collection('decks')
				.doc(deckId)
				.get();

		if (!snapshot.exists) {
			console.error('Deck not found');
			return;
		}

		const data = snapshot.data();
		if (!data.slides_ids || data.slides_ids.length <= 0) {
			console.error('No slides to move');
			return;
		}

		// data.slides_ids.splice(to, 0, ...data.slides_ids.splice(from, 1));

		var index = data.slides_ids.indexOf(blockid);
		if (index !== -1) {
			await data.slides_ids.splice(index, 1);
		}

		await db
				.collection('decks')
				.doc(deckId)
				.set(data, {merge: true});

		console.log('Deck updated');
		if(isUndo){
			// is undo
			console.log(isUndo)
		}else{
			await updateHistory(deckId, blockid, {
				function: "remove",
				data: {
					slide_id: blockid
				}
			})
		}
	}

	// (async () => {
	// 	try {
	// 		const deckId = await createDeck();
	// 		// const deckId = boardID

	// 		console.log(deckId)
			
	// 		await createSlide(deckId, 'Slide 1');
	// 		await createSlide(deckId, 'Slide 2');
	// 		await createSlide(deckId, 'Slide 3');
	// 		await printSlides(deckId);
	// 		await moveSlide(deckId, 1, 0);
	// 		await printSlides(deckId);
	// 	} catch (err) {
	// 		console.error(err);
	// 	}
	// })();

	function removeBoard() {
      // selectedBoard = boardID
			if(confirmed == true){
				dispatch("delete", {
					id: boardID
				});
			}else{
				notifications.warning("To delete the deck, type it's name exactly", 2000)
			}
  }

	let options = {
		sort: true,
		delay: 200,
		delayOnTouchOnly: true,
	}
	if(permissions != "true"){
		options = {
			sort: false,
			delay: 200,
			delayOnTouchOnly: true,
		}
	}


	export let deleteConfirmation=""
	let confirmed = false;
	export let menuVisible = true
	function toggleMenu(){
		menuVisible = !menuVisible
	}

	function verifyInput(){
		if(deleteConfirmation == title){
			confirmed=true;
		}else{
			confirmed = false;
		}
		console.log(confirmed)
	}

</script>


<svelte:window on:keydown={handle_keydown}/>



<!-- <p>{boardID}</p> -->


<Sortable { todos }
					list = {list}
					uploading={uploading}
					let:item={item}
					options={options}
					permissions={permissions} 
					on:change={onReorder}
					on:upload={createSlide}
					>
					
	<Slide {...item}
						blockid={item.block_id} 
						on:remove={removeItem} 
						on:toggle={updateStatus} 
						permissions={permissions} />
</Sortable>

<div class="delete-menu" class:hidden={menuVisible==true}>
	<div class="delete-card">
		<p class="type-m">Are you sure?</p>
		<p class="type-s">To delete this deck, please type the name of the board: </p>
		<b>{title}</b>
		<br>
		<input class="minimalInput" bind:value={deleteConfirmation} on:input={verifyInput} type="text" placeholder="Type here to confirm">
		<button class="button" class:disabled={!confirmed} on:click={removeBoard}>Confirm</button>
		<button class="button" on:click={toggleMenu}>Close</button>
		<p class="type-sm">&nbsp;</p>
		<p class="type-sm">{deleteConfirmation}</p>
	</div>
</div>

{#if permissions == "true"}
<button class="deleteButton minimalButton" on:click={()=>toggleMenu()}>Delete Deck</button>
{/if}


<style>
	br{
		margin: 4px;
	}
	.dark{
		background-color: black;
	}
	input {
		display: block;
	}

	.deleteButton{
		position: fixed;
		bottom: 2px;
		right: 2px;
	}
	.demo-widget {
		background: #f1f1f1;
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.demo-container {
		/* max-width: 800px;; */
		width: 100%;
	}
	input[type="file"] {
		display: none;
	}
	.full-file{
		border: 0px solid #ccc;
		display: inline-block;
		padding: 6px 12px;
		cursor: pointer;
		position: absolute;
		width: 100%;
		height: 100%;
	}
	.add-btn{
		display: none;
	}
	.delete-menu{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0px;
		left: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		pointer-events: none;
		z-index: 40;
	}
	.delete-background{
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #00000010;
		pointer-events: all;
	}
	.delete-card{
		background-color: rgb(165, 129, 82);
		pointer-events: all;
		border-radius: 8px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.267);
		color: white;
		padding: 30px;
	}

	b{
		color: rgb(255, 244, 142);
	}

	.minimalInput{
        border: none;
				display: inline-block;
        background-color: rgba(0, 0, 0, 0.062);
        color: white;
        font-size: 18px;
        line-height: 1;
				padding: 4px;
				border-radius: 4px;
    }
    .minimalInput::placeholder{
        color: white;
        font-size: 18px;
        line-height: 1;
    }
    .minimalInput:focus {outline:0;}

		.button{
		margin-top: 6px;
		border: none;
		padding: 8px 12px;
		background: #EFF0F2;
		color: black;
		cursor: pointer;
		border-radius: 6px;
	}

	.button:disabled:hover{
		background: #EFF0F2;
		color: black;
	}
	.button:hover{
		background: rgba(0, 0, 0, 0.963);
		color: white;
	}
</style>
